import Icon from "@mui/material/Icon";
import { JSX } from "react";
import DashBoard from "./pages/dashboard";
import InqueryList from "./pages/inquery";
import TroubleList from "./pages/trouble";
import VideoList from "./pages/video";
import UserList from "./pages/user";
import HandLoadList from "./pages/handload";
import ParamList from "./pages/param";
import InqueryEdit from "./pages/inquery/inqueryEdit";
import ProductList from "./pages/master/product";
import PlaceList from "./pages/master/place";

import { AddCall,Troubleshoot,AppShortcut,FormatIndentIncrease,VideoLibrary,Person,Engineering,LocationCity, Code,Error,BugReport,Source } from "@mui/icons-material";
import SignIn from "./pages/sign/SignIn";
import ErrorList from "./pages/error";
import VideoInsert from "./pages/video/VideoInsert";
import InqueryInsert from "./pages/inquery/inqueryInsert";
import TroubleInsert from "./pages/trouble/troubleInsert";
import TroubleEdit from "./pages/trouble/troubleEdit";
import CodeList from "./pages/master/code";
import ErrorEdit from "./pages/error/errorEdit";
import ErrorInsert from "./pages/error/errorInsert";
import ParamInsert from "./pages/param/paramInsert";
import ParamEdit from "./pages/param/paramEdit";
import HandInsert from "./pages/handload/handInsert";
import HandEdit from "./pages/handload/handEdit";
import UserInsert from "./pages/user/userInsert";
import UserEdit from "./pages/user/userEdit";
import PlaceInsert from "./pages/master/place/placeInsert";
import PlaceEdit from "./pages/master/place/placeEdit";
import ProductInsert from "./pages/master/product/productInsert";
import ProductEdit from "./pages/master/product/productEdit";
import TestBoardList from "./pages/testboard";
import TestBoardEdit from "./pages/testboard/testBoardEdit";
import TestBoardInsert from "./pages/testboard/testBoardInsert";
import PdsList from "./pages/pds";
import PdsEdit from "./pages/pds/pdsEdit";
import PdsInsert from "./pages/pds/pdsInsert";
import TestBoardView from "./pages/testboard/testBoardView";


export type T_route = {
  key: string;
  type?: string;
  title?: string;
  name?: string;
  route: string;
  icon?: JSX.Element;
  component?: JSX.Element;
  routes?: T_route[];
  protected?:boolean;
  auth?:string[];
  noCollapse?:string;
  href?:string;
};

const routes: T_route[] = [
  // {
  //   key: "dashboard",
  //   type: "collapse",
  //   name: "대시보드",
  //   route: "/dashboard",
  //   auth:["ADMIN","MANAGER","USER"],
  //   icon: <Icon fontSize="small">dashboard</Icon>,
  //   component: <DashBoard />,
  // },
  {
    key: "inquery",
    type: "collapse",
    title:"고객문의",
    name: "고객문의",
    route: "/inquery",
    icon: <AddCall/>,
    component: <InqueryList />,
    routes:[{
      key: "inquery/edit",
      route: "/inquery/edit",
      component: <InqueryEdit />,
    },
    {
      key: "inquery/insert",
      route: "/inquery/insert",
      component: <InqueryInsert />,
    }
  ]    
  },
  {
    key: "trouble",
    type: "collapse",
    name: "트러블슈팅",
    route: "/trouble",
    auth:["ADMIN"],
    icon: <Troubleshoot />,
    component: <TroubleList />,
    routes:[{
      key: "trouble/edit",
      route: "/trouble/edit",
      component: <TroubleEdit />,
    },
    {
      key: "trouble/insert",
      route: "/trouble/insert",
      component: <TroubleInsert />,
    }
  ]    
  },
  {
    key: "handy",
    type: "collapse",
    name: "핸디로더",
    route: "/handy",
    auth:["ADMIN"],
    icon: <AppShortcut/>,
    component: <HandLoadList />,
    routes:[{
      key: "handy/edit",
      route: "/handy/edit",
      component: <HandEdit />,
    },
    {
      key: "handy/insert",
      route: "/handy/insert",
      component: <HandInsert />,
    }
  ]    
  },
  {
    key: "error",
    type: "collapse",
    name: "에러관리",
    route: "/error",
    auth:["ADMIN"],
    icon: <Error/>,
    component: <ErrorList />,
    routes:[{
      key: "error/edit",
      route: "/error/edit",
      component: <ErrorEdit />,
    },
    {
      key: "error/insert",
      route: "/error/insert",
      component: <ErrorInsert />,
    }
  ]    
  },
  {
    key: "param",
    type: "collapse",
    name: "파라미터",
    route: "/param",
    auth:["ADMIN"],
    icon: <FormatIndentIncrease/>,
    component: <ParamList />,
    routes:[{
      key: "param/edit",
      route: "/param/edit",
      component: <ParamEdit />,
    },
    {
      key: "param/insert",
      route: "/param/insert",
      component: <ParamInsert />,
    }
  ]    
  },
    {
    key: "video",
    type: "collapse",
    name: "영상관리",
    route: "/video",
    auth:["ADMIN"],
    icon: <VideoLibrary/>,
    component: <VideoList />,
    routes:[{
      key: "video/inser",
      route: "/video/insert",
      component: <VideoInsert />,
    }]    

    }
  ,
  {
    key: "user",
    type: "collapse",
    name: "회원관리",
    route: "/user",
    auth:["ADMIN"],
    icon: <Person/>,
    component: <UserList />,
    routes:[{
      key: "user/edit",
      route: "/user/edit",
      component: <UserEdit />,
    },
    {
      key: "user/insert",
      route: "/user/insert",
      component: <UserInsert />,
    }
  ]    
  }
  ,
  {
    key:"master",
    type: "title",
    route:"/master",
    name: "마스터관리",
    auth:["ADMIN"],
    icon: <Icon fontSize="small">dashboard</Icon>,
    routes:[
      {
      key:"product",
      type: "collapse",
      route:"/product",
      name: "제품관리",
      icon:<Engineering/>,
      component:<ProductList />,
      routes:[{
        key: "product/edit",
        route: "/product/edit",
        component: <ProductEdit />,
      },
      {
        key: "product/insert",
        route: "/product/insert",
        component: <ProductInsert />,
      }
    ]    
      },
      {
        key:"place",
        type: "collapse",
        route:"/place",
        name: "현장관리",
        icon:<LocationCity/>,
        component:<PlaceList />,
        routes:[{
          key: "place/edit",
          route: "/place/edit",
          component: <PlaceEdit/>,
        },
        {
          key: "place/insert",
          route: "/place/insert",
          component: <PlaceInsert />,
        }
      ]    
        },
        {
          key:"code",
          type: "collapse",
          route:"/code",
          name: "코드관리",
          icon:<Code/>,
          component:<CodeList />
          }
  
    ]
  }
   ,
  {
    key: "testboard",
    type: "collapse",
    name: "테스트현황",
    route: "/testboard",
    auth:["ADMIN"],
    icon: <BugReport/>,
    component: <TestBoardList />,
    routes:[{
      key: "testboard/edit",
      route: "/testboard/edit",
      component: <TestBoardEdit />,
    },
    {
      key: "testboard/insert",
      route: "/testboard/insert",
      component: <TestBoardInsert />,
    },
    {
      key: "testboard/view",
      route: "/testboard/view",
      component: <TestBoardView />,
    }
  ]    
  }
    ,
  {
    key: "pds",
    type: "collapse",
    name: "자료실",
    route: "/pds",
    auth:["ADMIN"],
    icon: <Source/>,
    component: <PdsList />,
    routes:[{
      key: "pds/edit",
      route: "/pds/edit",
      component: <PdsEdit />,
    },
    {
      key: "pds/insert",
      route: "/pds/insert",
      component: <PdsInsert />,
    }
  ]    
  }
];

export default routes;
